import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useContext } from 'react';
import DataContext from '../../../store/DataContext';
import WizardDataContext from '../../../store/WizardDataContext';

export default function LogoUploadSuccess({ image, setImage, setImageUploaded }) {
  const dataCtx = useContext(DataContext);
  const wizardCtx = useContext(WizardDataContext);

  const wizardLogoUrl = wizardCtx?.wizardData?.logo?.url;
  const legacyLogoUrl = dataCtx?.step2?.logo;
  const storedLogoUrl = wizardLogoUrl || legacyLogoUrl || null;

  const handleClearImg = () => {
    setImage(null)
    setImageUploaded(false)
    // Also clear the logo from legacy context (if available)
    if (dataCtx && dataCtx.setStep2) {
      dataCtx.setStep2({ ...dataCtx.step2, logo: null })
    }
    // And clear from wizard context (if available)
    if (wizardCtx && wizardCtx.updateData) {
      wizardCtx.updateData('logo', { url: null })
    }
  }

    return (
    <>
      <div className="step2c-container">
        <div className="step2c">
          <div className="step2c-heading">
            <h2>Company Logo</h2>
          </div>
          <div>
            {(image || storedLogoUrl) && (
              <img 
                src={image ? URL.createObjectURL(image) : storedLogoUrl} 
                alt="Company logo" 
                style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain',borderRadius: '8px',padding: '10px'}} 
              />
            )}
          </div>
          <div className="step2c-drop-text">
            <h3>Your logo is loaded</h3>
            <div className="file-name"> 
              <span>
                {image ? image.name : (storedLogoUrl ? 'Company Logo' : null)}
              </span> 
              <CloseRoundedIcon onClick={handleClearImg} /> 
            </div> 
          </div>
         </div>
        </div>
    </>

    )
  }
